<app-sales-comparison-marketing-subheader
  [(startDate)]="startDate"
  [(endDate)]="endDate"
  [(period)]="period"

  [(salesTeamIds)]="salesTeamIds"
  [(salesPersonIds)]="salesPersonIds"
  [(campaignIds)]="campaignIds"
  [(mediumIds)]="mediumIds"
  [(sourceIds)]="sourceIds"

  [salesTeamIdAllValue]="salesTeamIdAllValue"
  [salesPersonIdAllValue]="salesPersonIdAllValue"
  [campaignIdAllValue]="campaignIdAllValue"
  [mediumIdAllValue]="mediumIdAllValue"
  [sourceIdAllValue]="sourceIdAllValue"

  (startDateChange)="onStartDateChange($event)"
  (endDateChange)="onEndDateChange($event)"
  (salesTeamIdsChange)="onSalesTeamIdsChange($event)"
  (salesPersonIdsChange)="onSalesPersonIdsChange($event)"
  (campaignIdsChange)="onCampaignIdsChange($event)"
  (sourceIdsChange)="onSourceIdsChange($event)"
  (mediumIdsChange)="onMediumIdsChange($event)"
/>

<div>
  <div class="details-content container-fluid h-100">
    <div class="row h-100">
      <div class="col-content d-flex flex-column h-100">
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                @if (
                  marketingPerformanceData$ | async; as marketingPerformanceData
                  ) {
                  <div
                    class="row mt-2"
                  >
                    <div class="col-12 col-md">
                      <app-generic-grid
                        style="height: 300px"
                        [data]="marketingPerformanceData"
                        [tabViewName]="'marketingPerformanceReport'"
                        [pageSize]="15"
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
